import { telemetry } from '../backend';
import checkCapacitorAndPluginsAvailable from '../helper-functions';

export const insomniaKeepAwake = checkCapacitorAndPluginsAvailable(
  ['insomnia'],
  () => {
    window.plugins.insomnia.keepAwake(
      () => {
        // Successful
      },
      (insomniaError) => {
        // Unsuccessful
        // We don't care really... The main thing is that the trip starts
        // Need to work out how often this happens
        telemetry(
          telemetry.WARN,
          `[Insomnia.service] Failed to allow screen to lock again: ${insomniaError}`,
        );
      },
    );
  },
);

export const insomniaAllowSleep = checkCapacitorAndPluginsAvailable(
  ['insomnia'],
  () => {
    window.plugins.insomnia.allowSleepAgain(
      () => {
        // Successful
        telemetry(
          telemetry.DEBUG,
          `[Insomnia.service] Allowing screen to lock`,
        );
      },
      (insomniaError) => {
        // Unsuccessful - this will happen for two reasons. One, the plugin hasn't been told to keepAwake. Two, something within the plugin went wrong.
        // We need to make sure it allows the sleep again...
        // But we also need to make sure we finish the trip...
        // Need to also know how often it fails

        telemetry(
          telemetry.WARN,
          `[Insomnia.service] Failed to allow screen to lock again: ${insomniaError}`,
        );
      },
    );
  },
);
